import { createContext } from "react";
import type { AnfrageDraftOut } from "@/lib/anfragen";

export type AnfrageWizardNoticeHandler = (message: string) => void;
export type AnfrageWizardChangedHandler = () => void;

export interface AnfrageWizardContextValue {
  openNew: () => void;
  openDraft: (draft: AnfrageDraftOut) => void;
  openDraftById: (
    id: number,
    opts?: { sourceMaId?: number; title?: string },
  ) => Promise<void>;
  isOpen: boolean;
  subscribeNotice: (listener: AnfrageWizardNoticeHandler) => () => void;
  subscribeAnfragenChanged: (listener: AnfrageWizardChangedHandler) => () => void;
}

export const AnfrageWizardContext = createContext<AnfrageWizardContextValue | null>(null);
